import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full max-w-lg rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }
const _hoisted_3 = { class: "mb-2 text-catering-ink-900" }
const _hoisted_4 = {
  key: 0,
  class: "text-catering-ink-500"
}
const _hoisted_5 = { class: "overflow-x-auto" }
const _hoisted_6 = { class: "w-full text-left text-xs" }
const _hoisted_7 = { class: "divide-y divide-catering-cream-300" }
const _hoisted_8 = { class: "py-1.5 pr-2" }
const _hoisted_9 = { class: "py-1.5 pr-2 text-right tabular-nums" }
const _hoisted_10 = { class: "py-1.5 pr-2 text-right tabular-nums" }
const _hoisted_11 = { class: "py-1.5 text-right tabular-nums" }
const _hoisted_12 = {
  key: 0,
  class: "mt-2 text-[11px] text-catering-ink-500"
}


export default {
  __name: 'BotSmsOptOutSummary',
  props: { block: { type: Object, required: true } },
  setup(__props) {



const LABELS = {
  no_paid_orders: 'No paid orders',
  single_order_churned: 'Single order · churned',
  single_order_recent: 'Single order · recent',
  repeat_customers: 'Repeat customers'
}
const segmentLabel = key => LABELS[key] || key

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, " SMS opt-outs · last " + _toDisplayString(__props.block.days) + " days ", 1),
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(_toDisplayString(__props.block.opted_out_customers) + " " + _toDisplayString(__props.block.opted_out_customers === 1 ? 'customer' : 'customers') + " replied STOP ", 1),
      (__props.block.truncated)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(most recent shown)"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
          _createElementVNode("tr", { class: "text-catering-ink-500" }, [
            _createElementVNode("th", { class: "py-1 pr-2 font-medium" }, "Segment"),
            _createElementVNode("th", { class: "py-1 pr-2 text-right font-medium" }, "Customers"),
            _createElementVNode("th", { class: "py-1 pr-2 text-right font-medium" }, "Avg texts before STOP"),
            _createElementVNode("th", { class: "py-1 text-right font-medium" }, "Avg days to STOP")
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.segments || [], (s) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: s.segment,
              class: "text-catering-ink-800"
            }, [
              _createElementVNode("td", _hoisted_8, _toDisplayString(segmentLabel(s.segment)), 1),
              _createElementVNode("td", _hoisted_9, _toDisplayString(s.customers), 1),
              _createElementVNode("td", _hoisted_10, _toDisplayString(s.avg_sms_before_opt_out ?? '—'), 1),
              _createElementVNode("td", _hoisted_11, _toDisplayString(s.avg_days_to_opt_out ?? '—'), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    (__props.block.note)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(__props.block.note), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}